import { Service, ServiceActionType } from '../types';
import { ServiceActionTypes } from '../constants';
import getActionName from './getActionName';
import actionMeta from './actionMeta';

export default function actionName(
  service: Service,
  actionKey: string,
  typeOf: ServiceActionType = ServiceActionTypes.READ as ServiceActionType,
  options: { hasNoVerb: boolean }
) {
  const action = actionMeta(service, actionKey, typeOf);
  return getActionName(action, options);
}
